'use client';

import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import { useId, useState, type ReactNode } from 'react';
import { Icon, IconType } from '@/components/Icon';

interface CollapsibleProps {
  header: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  centered?: boolean;
}

export const Collapsible = ({
  header,
  children,
  className,
  contentClassName,
  centered = false,
}: CollapsibleProps) => {
  const [expanded, setExpanded] = useState(false);
  const contentId = useId();

  return (
    <div className={classNames('bg-card-bg rounded-2xl px-2', className)}>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        aria-controls={contentId}
        className={classNames(
          'flex w-full items-center gap-2 p-2',
          centered ? 'justify-center' : 'text-left',
        )}
      >
        <span className={centered ? undefined : 'flex-1'}>{header}</span>
        <Icon
          src={IconType.SvgChevronDown}
          size={20}
          className={classNames(
            'shrink-0 transition-transform',
            expanded ? 'rotate-180' : '',
          )}
        />
      </button>
      <div
        id={contentId}
        hidden={!expanded}
        aria-hidden={!expanded}
        className={contentClassName ?? 'px-4 pb-4'}
      >
        {children}
      </div>
    </div>
  );
};
